export class EntryCode {
  public constructor(
    public code: string,
    public text: string
  ) {}
}
